import { useAtom } from "jotai";
import { useCallback, useEffect } from "react";
import { currentSpaceAtom } from "../jotai/atoms";
import useInterval from "../utils/useInterval";

export function useSyncApi() {
  const [currentSpace] = useAtom(currentSpaceAtom);

  const sync = useCallback(
    (force?: boolean) => {
      if (!currentSpace) return;

      fetch(
        `/api/space/sync?spaceId=${currentSpace.id}${force ? "&force=1" : ""}`
      )
        .then((res) => {
          if (res.status !== 200) {
            console.error("sync error: " + res.statusText);
          }
        })
        .catch((e) => console.error(e));
    },
    [currentSpace]
  );

  // sync on space change
  useEffect(() => {
    return () => {
      if (currentSpace) {
        sync();
      }
    };
  }, [currentSpace, sync]);

  return sync;
}

export function useSync() {
  const sync = useSyncApi();

  useEffect(() => {
    const f = () => sync;
    window.addEventListener("beforeunload", f);
    return () => {
      window.removeEventListener("beforeunload", f);
    };
  }, [sync]);

  useInterval(sync, 15 * 60 * 1000); // 15 min
}
